import { render, staticRenderFns } from "./MessageMenu.vue?vue&type=template&id=a68fecf0&scoped=true&"
import script from "./MessageMenu.vue?vue&type=script&lang=js&"
export * from "./MessageMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessageMenu.vue?vue&type=style&index=0&id=a68fecf0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68fecf0",
  null
  
)

component.options.__file = "MessageMenu.vue"
export default component.exports